var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2728 7.83185C15.7066 7.83185 16.0511 7.45259 15.9937 7.02275C15.981 6.92161 15.9682 6.82049 15.9491 6.71935C15.9427 6.68142 15.9363 6.64349 15.9299 6.61188C15.2728 2.85714 11.9742 0 7.99942 0C4.01821 0 0.726066 2.85714 0.0689116 6.61188C0.0625315 6.64981 0.0561327 6.68774 0.0497525 6.71935C0.0306121 6.82049 0.0178667 6.92161 0.00510638 7.02275C-0.0459347 7.45259 0.292216 7.83185 0.726065 7.83185H15.2728Z",
    fill: "#8A8989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 9.19089C7.58521 9.19089 7.24707 9.5259 7.24707 9.93677V14.2541C7.24707 14.665 7.58521 15 7.99992 15C8.41463 15 8.75277 14.665 8.75277 14.2541V9.93677C8.75277 9.5259 8.41463 9.19089 7.99992 9.19089Z",
    fill: "#8A8989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69576 9.66504C1.40228 9.37427 0.923757 9.37427 0.630271 9.66504C0.336785 9.95581 0.336785 10.4299 0.630271 10.7143L4.42007 14.4691C4.71356 14.7598 5.19207 14.7598 5.47918 14.4691C5.77267 14.1783 5.77267 13.7042 5.47918 13.4198L1.69576 9.66504Z",
    fill: "#8A8989"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3752 9.66504C15.0817 9.37427 14.6032 9.37427 14.3161 9.66504L10.5263 13.4198C10.2328 13.7106 10.2328 14.1846 10.5263 14.4691C10.8198 14.7598 11.2983 14.7598 11.5854 14.4691L15.3752 10.7143C15.6687 10.4299 15.6687 9.95581 15.3752 9.66504Z",
    fill: "#8A8989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputDropIcon);
export default __webpack_public_path__ + "static/media/input-drop-icon.aaca0733f0b154dcfd2ba30a262fbdde.svg";
export { ForwardRef as ReactComponent };